export default {
    menu_label: 'Governance',

    overview: {
        title: 'Broadcast Governance',
        subtitle: 'Every referral broadcast — rounds, provider contacts, and outcomes',
        loading: 'Loading broadcasts…',
        error: 'Unable to load broadcasts. Please try again.',
        empty: 'No broadcasts for the selected filters.',
        filters: {
            status: 'Status',
            any_status: 'Any status',
            date_range: 'Date range',
            from_date: 'From',
            to_date: 'To',
        },
        table: {
            referral: 'Referral',
            status: 'Status',
            round: 'Round',
            contacted: 'Contacted',
            created: 'Created',
            updated: 'Updated',
        },
    },

    detail: {
        title: 'Broadcast',
        back_to_overview: 'Back to all broadcasts',
        loading: 'Loading broadcast…',
        error: 'Unable to load this broadcast. Please try again.',
        not_found: 'This broadcast could not be found.',
        header: {
            referral: 'Referral',
            current_round: 'Current round',
            reserved_provider: 'Reserved provider',
            none: 'None',
        },
        actions: {
            stop: 'Stop broadcast',
            stop_confirm: 'Stop this broadcast? This cannot be undone.',
            run_round: 'Force next round',
            success: 'Done.',
            error: 'That action failed. Please try again.',
        },
        rounds: {
            title: 'Rounds',
            round: 'Round {round}',
            timeout: '{minutes} min timeout',
            expires_at: 'Expires',
            tier: 'Tier',
            suppressed: '{count} provider(s) suppressed (over invite cap)',
            empty: 'No rounds yet.',
        },
        contacts: {
            title: 'Provider contacts',
            provider: 'Provider',
            round: 'Round',
            status: 'Status',
            score: 'Score',
            confidence: 'Confidence',
            channels: 'Channels',
            why: 'Why this score',
            empty: 'No providers contacted yet.',
        },
        timeline: {
            title: 'Audit timeline',
            transition: '{from} → {to}',
            empty: 'No transitions recorded.',
        },
    },
}
